/**
 * Connected apps (MCP) service
 *
 * Backs Settings → Connected apps. Users connect Claude Code / Claude to their
 * AudioScribe account over OAuth (MCP). Removing the connection inside Claude
 * only clears that machine's stored credentials — the DELETE below is the only
 * thing that actually cuts access server-side.
 */

import { secureApiCallTemplate } from "./workspace.service";

const API_SERVER_URL = import.meta.env.VITE_API_SERVER_URL;

/**
 * List the MCP apps connected to the signed-in user's account.
 *
 * The API sends `Cache-Control: no-store`; the client-side GET cache is
 * bypassed for the same reason — a stale list would make a successful
 * disconnect look like it did nothing.
 *
 * @returns {Promise<{data: {connections: Array}|null, error: {message: string, status?: number}|null}>}
 */
export const getMcpConnections = async () => {
  console.log("Called the getMcpConnections method");

  const config = {
    url: `${API_SERVER_URL}/me/mcp-connections`,
    method: "GET",
  };

  return await secureApiCallTemplate(config, true); // always fresh
};

/**
 * Revoke an MCP app's access to the signed-in user's account.
 * Idempotent server-side: disconnecting an already-disconnected app succeeds.
 *
 * @param {string} connection - "claude-code" | "claude"
 * @returns {Promise<{data: object|null, error: {message: string, status?: number}|null}>}
 */
export const disconnectMcpConnection = async (connection) => {
  console.log("Called the disconnectMcpConnection method");

  const config = {
    url: `${API_SERVER_URL}/me/mcp-connections/${encodeURIComponent(
      connection,
    )}`,
    method: "DELETE",
  };

  return await secureApiCallTemplate(config, true);
};
